import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker } from '@fortawesome/free-brands-svg-icons';
import { faBrain } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "Python",
    "Docker",
    "ChromaDB",
    "Ollama",
    "Slack API",
    "PyAirtable",
    "Prompt engineering",
    "RAG / embeddings",
];

const labelsSecond = [
    "Java",
    "Spring Boot",
    "Vue 3",
    "TypeScript",
    "FastAPI",
    "React Native",
    "OracleDB",
    "REST APIs",
];

const labelsThird = [
    "Git",
    "GitHub",
    "Linux",
    "OpenCV",
    "NumPy",
    "Security testing",
    "Image processing",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faBrain} size="3x"/>
                    <h3>AI & LLM Applications</h3>
                    <p>I design and ship retrieval-augmented generation (RAG) workflows: schema-aware data ingestion, chunking, embedding-based retrieval, and LLM answer generation—so teams can query internal data in natural language with grounded, accurate responses.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>Full-Stack & Backend</h3>
                    <p>From modernizing legacy admin UIs to building batch-driven business workflows, I work across Spring Boot backends, Vue 3 frontends, and mobile clients—focusing on maintainability, scalability, and clear API boundaries.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Engineering Foundations</h3>
                    <p>Solid software engineering practices, containerized deployments, and hands-on work in security validation and research-grade data pipelines—from protocol-level testing to large-scale image preprocessing for ML.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;